import { render, staticRenderFns } from "./area-selector.vue?vue&type=template&id=61fd6574&scoped=true"
import script from "./area-selector.vue?vue&type=script&lang=js"
export * from "./area-selector.vue?vue&type=script&lang=js"
import style0 from "./area-selector.vue?vue&type=style&index=0&id=61fd6574&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fd6574",
  null
  
)

export default component.exports